export default "__VITE_ASSET__Blnb8Zim__"